module.exports = __webpack_public_path__ + "static/media/funding_czi.78777706.png";